import { ThunkDispatch } from '@reduxjs/toolkit';
import { Action } from 'redux';
import { useDispatch } from 'react-redux';
import { UncontrolledAlert } from 'reactstrap';
import { setError, setSuccess } from 'slices/product/form/reducer';
import { useEffect, useRef } from 'react';
import { RootState } from 'slices';

interface AlertWrapperProps {
  type: keyof AlertPropsType;
  message: string;
  heading: string;
}
type AlertTypeProps = {
  color: string;
  icon: string;
  closeAction: () => void;
};

type AlertPropsType = {
  success: AlertTypeProps;
  error: AlertTypeProps;
};

const AlertWrapper = ({ type, message, heading }: AlertWrapperProps) => {
  const dispatch: ThunkDispatch<RootState, void, Action> = useDispatch();

  const alertRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (message && alertRef.current) {
      alertRef.current.focus();
    }
  }, [message]);

  const alertProps: AlertPropsType = {
    success: {
      color: 'success',
      icon: 'ri-check-line',
      closeAction: () => dispatch(setSuccess('')),
    },
    error: {
      color: 'warning',
      icon: 'ri-alert-line',
      closeAction: () => dispatch(setError('')),
    },
  };

  if (!message) return null;

  return (
    <UncontrolledAlert
      data-testid="warn-alert-test"
      color={alertProps[type]?.color}
      className="alert-additional material-shadow mb-0"
      toggle={() => {
        alertProps[type]?.closeAction();
      }}
      innerRef={alertRef}
      tabIndex={-1}
    >
      <div className="alert-body">
        <div className="d-flex">
          <div className="flex-shrink-0 me-3">
            <i className={`${alertProps[type]?.icon} fs-16 align-middle`}></i>
          </div>
          <div className="flex-grow-1">
            <h5 className="alert-heading">{heading}</h5>
            <p className="mb-0">{message}</p>
          </div>
        </div>
      </div>
    </UncontrolledAlert>
  );
};

export default AlertWrapper;
